import {AfterContentInit, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {MapViewStore}                                                      from '../../stores/layout/mapview.store';
import {
  StatisticStore
}                                                                          from '../../stores/statistic/statistic.store';
import {ApStatsType, MapViewCurrentMenu, MapViewMode}                      from '../../ap-interface';
import {Subscription}                                                      from 'rxjs';
import {RouterStore}                                                       from '../../stores/router/router.store';
import {UserStore}                                                         from '../../stores/base-data/user.store';
import {LoginStore}                                                        from '../../stores/login/login.store';

/**
 * Component for the dashboard
 */
@Component({
  selector: 'ap-dashboard-overview',
  templateUrl: 'ap-dashboard.component.html',
  styleUrls: ['ap-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ApDashboardOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  private _subscriptions: Subscription[] = [];

  constructor(private routerStore: RouterStore,
              private userStore: UserStore,
              private loginStore: LoginStore,
              private mapViewStore: MapViewStore,
              private statisticStore: StatisticStore) {
  }

  public ngOnInit(): void {
    this._subscriptions.push(
      this.routerStore.Listen(s => s)
        .subscribe((routerStoreData) => {
          if (!routerStoreData.url?.startsWith('/dashboard')) {
            return;
          }
          if (routerStoreData.queryParams['redirectToNews'] === 'true') {
            // space for optional actions when user was redirected
            this.userStore.resetRedirectToNews(this.loginStore.UserId);
          }
        })
    );
    this._subscriptions.push(this.mapViewStore.Listen(x => x.currentMenu).subscribe(currentMenu => {
      if (currentMenu === MapViewCurrentMenu.STATS) {
        this.statisticStore.removeStatisticData();
        this.statisticStore.addStatisticData([], ApStatsType.DashboardStats, '', '');
      }
    }));
  }

  public ngAfterContentInit(): void {
    if (this.mapViewStore.getMapViewMode() !== MapViewMode.NORMAL) {
      this.mapViewStore.showMapView();
    }
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.STATS) {
      this.mapViewStore.goIntoStatisticMenu();
    }
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s?.unsubscribe());
    this.statisticStore.removeStatisticData();
  }
}
